import { APIRequest } from '../../helpers/index.helper';
import { SMS_CONVERSATION_ENDPOINT } from '../../apiEndpoints/SMSConversation/index.endPoint';
import { logger } from '../../utils';

export const getSMSConversationsService = async ({ queryParams }) => {
  try {
    const payload = {
      ...SMS_CONVERSATION_ENDPOINT.getConversations,
      queryParams,
    };
    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    logger(err);
  }
};

export const getSMSMessagesService = async (conversationId, queryParams) => {
  try {
    const payload = {
      ...SMS_CONVERSATION_ENDPOINT.getMessages(conversationId),
      queryParams,
    };
    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    logger(err);
  }
};

export const replySMSService = async ({ body }) => {
  try {
    const payload = {
      ...SMS_CONVERSATION_ENDPOINT.reply,
      bodyData: body,
    };
    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    logger(err);
    throw err;
  }
};

export const markSMSReadService = async (conversationId) => {
  try {
    const payload = {
      ...SMS_CONVERSATION_ENDPOINT.markRead(conversationId),
    };
    const res = await APIRequest(payload);
    return res;
  } catch (err) {
    logger(err);
  }
};
